<template>
    <div v-if="content" class="sosv-activity-calendar">
        <p class="parc-selection">Vous réservez pour le parc <b>City Aventure - Lyon Ste Foy</b></p>
        <osv-activity-calendar widget-options="showDuration=false;showRemainingPlace=false;timeSlotFormat=[Arrivée à ]HH[h]mm" />
    </div>
</template>
  
  <script>
export default {
    props: {
        content: null
    },
    data() {
        return {};
    },
    beforeMounted() {
    },
};
</script>
  
  <style lang="scss">
    .parc-selection {
        margin:20px auto;
        text-align:center;
        font-size:22px;
        b {
            font-weight:bold;
        }
    }
    .sosv-activity-calendar {
        max-width: $max-width;
        width:95%;
        margin:auto;
        margin-top:50px;
    }
  </style>
  